import { initialOf } from "../../../engine/selectors";
import "./Face.css";

/**
 * A player's face slot. Until they have taken a picture (stage 4 part B) it shows their initial.
 * Square on the wall, round up close: the shape comes from the root it sits in.
 * `stamped` puts the loser's stamp on it, `crowned` the favourite's crown; either wraps the face
 * in a `face-wrap` so the mark can sit over its edge.
 */
export function Face({
  name,
  src,
  className,
  stamped,
  crowned,
}: {
  name: string;
  src?: string | null;
  className?: string;
  stamped?: boolean;
  crowned?: boolean;
}) {
  const cls = className ? `face ${className}` : "face";
  const face = src ? (
    <img className={cls} src={src} alt="" loading="lazy" />
  ) : (
    <span className={cls} aria-hidden="true">
      {initialOf(name)}
    </span>
  );
  if (!stamped && !crowned) return face;
  return (
    <span className="face-wrap">
      {face}
      {stamped && <span className="face-stamp" aria-hidden="true" />}
      {crowned && <span className="face-crown" aria-hidden="true" />}
    </span>
  );
}
